import React, { useEffect, useRef } from "react";

const Canvas = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");
    let frameId;
    let width = 0;
    let height = 0;
    let circles = [];
    let lastTime = 0;

    const colors = ["#28c4ca", "#256bfe", "#087b85", "#13a876"];

    const createCircles = () => {
      const count = Math.min(
        42,
        Math.max(18, Math.round((width * height) / 48000)),
      );

      circles = Array.from({ length: count }, () => ({
        x: Math.random() * width,
        y: Math.random() * height,
        r: 18 + Math.random() * 92,
        dx: (Math.random() - 0.5) * 0.8,
        dy: -(0.35 + Math.random() * 0.75),
        phase: Math.random() * Math.PI * 2,
        drift: 0.25 + Math.random() * 0.55,
        color: colors[Math.floor(Math.random() * colors.length)],
        alpha: 0.045 + Math.random() * 0.075,
      }));
    };

    const resize = () => {
      const rect = canvas.parentElement.getBoundingClientRect();
      width = rect.width;
      height = rect.height;
      const pixelRatio = Math.min(window.devicePixelRatio || 1, 1.5);
      canvas.width = Math.round(width * pixelRatio);
      canvas.height = Math.round(height * pixelRatio);
      canvas.style.width = `${width}px`;
      canvas.style.height = `${height}px`;
      ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
      createCircles();
    };

    const draw = (time) => {
      const step = lastTime ? Math.min((time - lastTime) / 16.67, 2) : 1;
      lastTime = time;
      ctx.clearRect(0, 0, width, height);

      for (const c of circles) {
        c.phase += 0.012 * step;
        c.x += (c.dx + Math.sin(c.phase) * c.drift) * step;
        c.y += c.dy * step;

        if (c.x < -c.r) c.x = width + c.r;
        if (c.x > width + c.r) c.x = -c.r;
        if (c.y < -c.r) {
          c.y = height + c.r;
          c.x = Math.random() * width;
        }

        ctx.beginPath();
        ctx.arc(c.x, c.y, c.r, 0, Math.PI * 2);
        ctx.fillStyle = c.color;
        ctx.globalAlpha = c.alpha;
        ctx.fill();
      }
      ctx.globalAlpha = 1;
      frameId = requestAnimationFrame(draw); // now actually tracked
    };

    resize();
    draw();

    const resizeObserver = new ResizeObserver(resize);
    resizeObserver.observe(canvas.parentElement);

    return () => {
      cancelAnimationFrame(frameId);
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <div className="flowing-circles" aria-hidden="true">
      <canvas className="flowing-circles-canvas" ref={canvasRef} />
    </div>
  );
};

export default Canvas;
